import PersonalInfo from 'components/views/CreateLead/Personalnfo'

const CreateLeadPage = () => {
  return <PersonalInfo />
}

export default CreateLeadPage
